module.exports = __webpack_public_path__ + "static/nft-market-mobile-plp-b16ba92d1b9342c3f1f3be0aacbd2397.png";